<div class="accordion" id="{{properties.id1}}">
    <div class="accordion-item">
        <h2 class="accordion-header" id="{{properties.id2}}">
            <button class="accordion-button" type="button" [ngClass]="{'collapsed': !defaultExpand}"
                data-bs-toggle="collapse" attr.data-bs-target="#{{properties.id3}}"
                [attr.aria-expanded]="defaultExpand ? 'true' : 'false'" attr.aria-controls="{{properties.id3}}">

                <ng-container *ngIf="templateHeader; else headerContent">
                    <ng-container *ngTemplateOutlet="templateHeader;"></ng-container>
                </ng-container>
                <ng-template #headerContent>
                    {{properties.header}}
                </ng-template>
            </button>
        </h2>
        <div id="{{properties.id3}}" class="accordion-collapse collapse" [ngClass]="{'show': defaultExpand}"
            attr.aria-labelledby="{{properties.id2}}" attr.data-bs-parent="#{{properties.id1}}">
            <div class="accordion-body">
                {{properties.content}}
                <ng-container *ngTemplateOutlet="template;"></ng-container>
            </div>
        </div>
    </div>
</div>